module.exports = __webpack_public_path__ + "static/media/naturephoto_article_stimulatingvcm.6767b6d3.png";